import React, { useState, useEffect } from "react";
import LayoutWrapper from "@iso/components/utility/layoutWrapper.js";
import PageHeader from "@iso/components/utility/pageHeader";
import Box from "@iso/components/utility/box";
import AssetPage, { AssetModalGlobalStyles } from "./Asset.styles";
import IntlMessages from "@iso/components/utility/intlMessages";
import { configs } from "@iso/components/Tables/configs";
import { Button, Dropdown, Input, Menu, Pagination, Popconfirm, Modal, message } from "antd";
import {
  PlusOutlined,
  DownOutlined,
  EditOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  PaperClipOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  FileTextOutlined,
  UserOutlined,
  CalendarOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import modalActions from "@iso/redux/modal/actions";
import AssetModal from "@iso/containers/Pages/PropertyMap/components/Asset/AssetModal";
import EditAircraftModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditAircraftModal";
import EditFeedModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditFeedModal";
import EditFuelModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditFuelModal";
import EditGeneralAssetModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditGeneralAssetModal";
import EditTreatmentModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditTreatmentModal";
import EditWaterModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditWaterModal";
import EditAnimalModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditAnimalModal";
import EditWeatherModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditWeatherModal";
import EditSprayModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditSprayModal";
import EditStorageModal from "@iso/containers/Pages/PropertyMap/components/Asset/EditStorageModal";
import { assetService } from "@iso/services";
import { propertyService } from "../../../services/property.service";
import _ from "lodash";
import moment from "moment";
import Table from "@iso/components/collapsing-table/table";
import styled from "styled-components";
import { assetStates } from "@iso/constants/assetStates";
import SelectPropertyModal from "@iso/containers/Pages/Property/SelectPropertyModal";
import { levelTypes } from "@iso/constants/levelTypes";
import L from "leaflet";
import * as turf from "@turf/turf";
import inside from "point-in-polygon";
import AssetViewSummary from "./AssetViewSummary";
import Loader from "../../../components/utility/loader";
import AddAssetHistoryModal from "../PropertyMap/components/Asset/AddAssetHistoryModal";
import { activityService } from "../../../services/activity.service";
import AddActivityModal from "@iso/containers/Pages/PropertyMap/components/Asset/AddActivityModal";
import AssetAssignUserModal from "./AssetAssignUserModal";
import AssetSetExpiryModal from "./AssetSetExpiryModal";
import LogServiceModal from "./LogServiceModal";
import PreStartInspectionModal from "./PreStartInspectionModal";
import ChecklistTemplatesModal from "./ChecklistTemplatesModal";
import { isSuccess } from "@iso/lib/helpers/apiResponse";
import { markerGridHelper } from "@iso/lib/helpers/markerGridHelper";
const { openModal } = modalActions;

const Asset = (props) => {
  const [assets, setAssets] = useState([]);
  const dispatch = useDispatch();
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const activeProperty = localStorage.getItem("active_property");
  const activePermission = useSelector(
    (state) => state.permission.activePermission
  );
  const currentUser = useSelector((state) => state.user.user);

  const [liveStockData, setLiveStockData] = useState({});
  const [visibleEditLivestock, setVisibleEditLivestock] = useState(false);
  const [visibleViewSummary, setVisibleViewSummary] = useState(false);
  const [primaryObjects, setPrimaryObjects] = useState([]);
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [viewSummary, setViewSummary] = React.useState({});
  const [summaryDefaultTab, setSummaryDefaultTab] = useState("overview");
  const [visibleAssetTreatment, setVisibilityAssetTreatment] =
    React.useState(false);
  const [visibleAssetFuel, setVisibilityAssetFuel] = React.useState(false);
  const [visibleAssetFeed, setVisibilityAssetFeed] = React.useState(false);
  const [visibleAssetWater, setVisibilityAssetWater] = React.useState(false);
  const [loadingData, setLoadingData] = React.useState(false);
  const [visibleAssetAircraft, setVisibilityAssetAircraft] =
    React.useState(false);
  const [visibleAssetOther, setVisibilityAssetOther] = React.useState(false);
  const [dataAsset, setDataAsset] = useState({});
  const [visibleSelectProperty, setVisiblitySelectProperty] =
    React.useState(false);
  const [visibleAssetAnimal, setVisibilityAssetAnimal] = React.useState(false);
  const [visibleAssetStorage, setVisibilityAssetStorage] = React.useState(false);
  const [visibleAssetWeather, setVisibilityAssetWeather] =
    React.useState(false);
  const [visibleAssetSpray, setVisibilityAssetSpray] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchInput, setsearchInput] = React.useState("");
  const [viewHistory, setViewHistory] = React.useState(false);
  const [visibleAddHistory, setVisibleAddHistory] = useState(false);
  const [visibleModalActivity, setVisibleModalActivity] = useState(false);
  const [activityActive, setActivityActive] = useState(null);
  // Assign-user / set-expiry modal state. The two modals each track
  // their own target asset rather than sharing one — opening one
  // shouldn't clobber the other if the user clicks through the
  // dropdown quickly while a PUT is still in flight. `confirmLoading`
  // flips while the PUT is in flight so the modal's OK button shows a
  // spinner.
  const [visibleLogService, setVisibleLogService] = useState(false);
  const [logServiceAsset, setLogServiceAsset] = useState(null);
  const [visibleInspection, setVisibleInspection] = useState(false);
  const [visibleTemplateModal, setVisibleTemplateModal] = useState(false);
  const [inspectionAsset, setInspectionAsset] = useState(null);
  const [assetRefreshToken, setAssetRefreshToken] = useState(0);
  const [visibleAssignUser, setVisibleAssignUser] = useState(false);
  const [visibleSetExpiry, setVisibleSetExpiry] = useState(false);
  const [assignTargetAsset, setAssignTargetAsset] = useState(null);
  const [expiryTargetAsset, setExpiryTargetAsset] = useState(null);
  const [assignUserLoading, setAssignUserLoading] = useState(false);
  const [setExpiryLoading, setSetExpiryLoading] = useState(false);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const displayedVisitor = searchQuery?.slice(startIndex, endIndex);
  const [assetTotal, setAssetTotal] = useState(0);
  const displayData =
    props.search_result &&
    props.search_result.Facility?.slice(startIndex, endIndex);

  const handlePageSizeChange = (current, size) => {
    setCurrentPage(1);
    setPageSize(size);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const updatePropertyDetail = React.useCallback((id) => {
    propertyService.viewProperty(id).then((res) => {
      if (res.code === "0000") {
        setPrimaryObjects(res.primary_objects);
        setPropertyDetail(res.property);
      }
    });
  }, []);
  useEffect(() => {
    localStorage.setItem("assetLength", JSON.stringify(assets.length));
    if (props?.handleSafetyAssets) {
      // props.handlOpenmodal(showModal)
      props?.handleSafetyAssets(assets.length);
    }
  }, [assets]);
  useEffect(() => {
    if (activePropertyId) {
      updatePropertyDetail(activePropertyId);
    }
  }, [activePropertyId, updatePropertyDetail]);

  useEffect(() => {
    updateAssetData();
  }, [activePropertyId, searchInput, currentPage, pageSize]);

  const updateAssetData = () => {
    if (activePropertyId) {
      setLoadingData(true);
      const params = {
        'expand': 'spray',
        'is_paging': true,
        'page': currentPage,
        'search': searchInput,
        'page_size': pageSize
      };
      assetService.getList(activePropertyId, params).then((res) => {
        if (res.code === "0000") {
          setAssets(res.facilities);
          setAssetTotal(res.total_item);
          setSearchQuery(res.facilities);
          setLoadingData(false);
        }
      });
    }
  };

  useEffect(() => {
    updateAssetData();
  }, [activePropertyId]);
  useEffect(() => {
    if (!activeProperty) {
      setVisiblitySelectProperty(true);
    }
  }, []);

  useEffect(() => {
    propertyService.getProperties().then((res) => {
      if (res.properties.length === 0) {
        setVisiblitySelectProperty(true);
      }
    });
  }, [activePropertyId]);

  // The Asset Summary (and its eye shortcut) only applies to operable equipment;
  // other categories have no service/inspection/passport data, so hide both.
  const canViewSummary = (asset) =>
    asset?.category === "machinery" || asset?.category === "spray";

  const menu = (asset) => (
    <Menu onClick={handleMenuClick.bind(this, asset)}>
      <Menu.Item key="editDetails" icon={<EditOutlined />}>
        <IntlMessages id="propertyPage.managePage.editDetails" />
      </Menu.Item>
      {canViewSummary(asset) && (
        <Menu.Item key="viewSummary" icon={<EyeOutlined />}>
          <IntlMessages id="View Summary" />
        </Menu.Item>
      )}
      <Menu.Item key="addHistory" icon={<PlusCircleOutlined />}>
        <IntlMessages id="Add History" />
      </Menu.Item>
      {asset.category === 'education' && (
        <Menu.Item key="recordTraining" icon={<PlusCircleOutlined />}>
          <IntlMessages id="Record Training" />
        </Menu.Item>
      )}
      <Menu.Item key="history" icon={<FileTextOutlined />}>
        <IntlMessages id="View History" />
      </Menu.Item>
      {asset.category === "machinery" &&
        (activePermission == "owner" ||
          activePermission == "admin" ||
          activePermission == "safety") && (
          <Menu.Item key="logService" icon={<ToolOutlined />}>
            <IntlMessages id="Log Service" />
          </Menu.Item>
        )}
      {asset.category === "machinery" && (
        <Menu.Item key="inspection" icon={<FileTextOutlined />}>
          <IntlMessages id="Pre-start Inspection" />
        </Menu.Item>
      )}
      {/*
       * Assign User + Set Expiry — drive the expiry-reminder cron. The
       * backend gates these to owner/admin/safety via
       * AttachmentPermissionService::canManageOnProperty; we mirror the
       * gate here so the menu items don't even appear for other roles.
       */}
      {(activePermission == "owner" ||
        activePermission == "admin" ||
        activePermission == "safety") && (
        <Menu.Item key="assignUser" icon={<UserOutlined />}>
          {asset.assigned_user_id ? "Reassign User" : "Assign User"}
        </Menu.Item>
      )}
      {(activePermission == "owner" ||
        activePermission == "admin" ||
        activePermission == "safety") && (
        <Menu.Item key="setExpiry" icon={<CalendarOutlined />}>
          {asset.expiry_date ? "Edit Expiry" : "Set Expiry"}
        </Menu.Item>
      )}
      {(activePermission == "owner" || activePermission == "admin") && (
        <p style={{ cursor: "pointer" }} className="deleteButton">
          <Popconfirm
            placement="bottomRight"
            title="You are about to delete individual record"
            onConfirm={() => {
              confirmDelete(asset);
            }}
            okText="Yes"
            cancelText="No"
            className="delete-button"
          >
            <a style={{ color: "rgba(0, 0, 0, 0.65)", marginLeft: "11px" }}>
              {<DeleteOutlined />}&nbsp;&nbsp;
              <IntlMessages id="propertyPage.managePage.delete" />
            </a>
          </Popconfirm>
        </p>
      )}
    </Menu>
  );
  const handleMenuClick = (asset, e) => {
    if (e.key === "editDetails") {
      setViewHistory(false);
      setDataAsset(asset);
      if (
        asset.type === "animal_treatment" ||
        asset.type === "fertiliser" ||
        asset.type === "vaccine"
      ) {
        setVisibilityAssetTreatment(true);
      }

      if (asset.type === "fuel" || asset.type === "chemical") {
        setVisibilityAssetFuel(true);
      }

      if (asset.type === "stock_feed") {
        setVisibilityAssetFeed(true);
      }

      if (asset.type === "water") {
        setVisibilityAssetWater(true);
      }

      if (asset.type === "aircraft") {
        setVisibilityAssetAircraft(true);
      }

      if (asset.category === "storage") {
        setVisibilityAssetStorage(true);
      }

      if (asset.type === "other") {
        setVisibilityAssetOther(true);
      }

      if (asset.category === "animal") {
        setVisibilityAssetAnimal(true);
      }

      if (asset.category === "weather") {
        setVisibilityAssetWeather(true);
      }

      if (asset.category === "spray") {
        setVisibilityAssetSpray(true);
      }

      if (
        asset.category !== "inventory" &&
        asset.category !== "animal" &&
        asset.category !== "weather" && 
        asset.category !== "spray" &&
        asset.category !== "storage" 
      ) {
        setVisibilityAssetOther(true);
      }
    }
    if (e.key === "viewSummary") {
      setSummaryDefaultTab("overview");
      setVisibleViewSummary(true);
      setViewSummary(asset);
    }
    if (e.key === "logService") {
      setLogServiceAsset(asset);
      setVisibleLogService(true);
    }
    if (e.key === "inspection") {
      setInspectionAsset(asset);
      setVisibleInspection(true);
    }
    if (e.key === "history") {
      setDataAsset(asset);

      if (asset.category === "machinery") {
        // Machinery service history lives in the new Service History tab of the
        // View Summary modal — the legacy activity-history view doesn't include
        // service_logs. The Timeline tab still shows broader asset activity.
        setSummaryDefaultTab("history");
        setViewSummary(asset);
        setVisibleViewSummary(true);
      }

      if (
        asset.type === "animal_treatment" ||
        asset.type === "fertiliser" ||
        asset.type === "vaccine"
      ) {
        setVisibilityAssetTreatment(true);
        setViewHistory(true);
      }

      if (asset.type === "fuel" || asset.type === "chemical") {
        setVisibilityAssetFuel(true);
        setViewHistory(true);
      }

      if (asset.type === "stock_feed") {
        setVisibilityAssetFeed(true);
        setViewHistory(true);
      }

      if (asset.category === "storage") {
        setVisibilityAssetStorage(true);
        setViewHistory(true);
      }

      if (asset.type === "water") {
        setVisibilityAssetWater(true);
        setViewHistory(true);
      }

      if (asset.type === "aircraft") {
        setVisibilityAssetAircraft(true);
        setViewHistory(true);
      }

      if (asset.type === "other") {
        setVisibilityAssetOther(true);
        setViewHistory(true);
      }

      if (asset.category === "animal") {
        setVisibilityAssetAnimal(true);
        setViewHistory(true);
      }

      if (asset.category === "weather") {
        setVisibilityAssetWeather(true);
        setViewHistory(true);
      }

      if (asset.category === "spray") {
        setVisibilityAssetWeather(true);
        setViewHistory(true);
      }

      if (
        asset.category !== "inventory" &&
        asset.category !== "animal" &&
        asset.category !== "weather" &&
        asset.category !== "storage" &&
        asset.category !== "machinery"
      ) {
        setVisibilityAssetOther(true);
        setViewHistory(true);
      }
    }
    if (e.key === "addHistory") {
      setDataAsset(asset);
      setVisibleAddHistory(true);
    }
    if (e.key === "assignUser") {
      setAssignTargetAsset(asset);
      setVisibleAssignUser(true);
    }
    if (e.key === "setExpiry") {
      setExpiryTargetAsset(asset);
      setVisibleSetExpiry(true);
    }
    if (e.key === "recordTraining") {
      // The trainer-only gate is skipped when the asset has any external
      // trainer (primary or secondary), because external trainers don't have
      // system accounts and any registered user listed as a trainer (or the
      // creator) needs to be able to record on their behalf. When all trainers
      // are registered users, we still enforce the gate so unauthorised users
      // can't submit training records.
      const educationAsset = asset.education_asset;
      const hasExternalTrainer = educationAsset && (
        !!educationAsset.primary_external_trainer
        || (Array.isArray(educationAsset.secondary_external_trainers) && educationAsset.secondary_external_trainers.length > 0)
      );
      if (educationAsset && !hasExternalTrainer) {
        const currentUserId = currentUser?.id;
        const isPrimaryTrainer = educationAsset.primary_trainer_id === currentUserId;
        const secondaryTrainerIds = educationAsset.secondary_trainer_ids || [];
        const isSecondaryTrainer = Array.isArray(secondaryTrainerIds)
          ? secondaryTrainerIds.includes(currentUserId)
          : false;

        if (!isPrimaryTrainer && !isSecondaryTrainer) {
          Modal.error({
            title: 'Not Authorized',
            content: 'You are not authorized to record training for this education asset. Only primary or secondary trainers can record training sessions.',
          });
          return;
        }
      }

      setDataAsset(asset);
      setActivityActive('training_session');
      setVisibleModalActivity(true);
    }
  };

  const confirmDelete = (del_asset) => {
    if (del_asset.id) {
      assetService.destroy(del_asset.id).then((res) => {
        if (res.code === "0000") {
          updateAssetData();
        }
      });
    }
  };

  const cancelSelectPropertyModal = () => {
    setVisiblitySelectProperty(false);
  };

  const columns = [
    {
      label: <IntlMessages id="assetPage.table.name" />,
      accessor: "title",
      minWidth: 100,
      sortable: true,
      position: 1,
      priorityLevel: 1,
      CustomComponent: (cell) => {
        let asset = cell.row;

        const hasAttachment = asset.attachment; // Replace with your attachment presence condition
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginLeft: hasAttachment ? 10 : 0 }}>
              {asset.title}
            </div>
            {hasAttachment.length > 0 && (
              <PaperClipOutlined style={{ color: "#0B2A1B" }} />
            )}{" "}
            {/* Add the PaperclipIcon conditionally */}
          </div>
        );
      },
    },
    {
      label: <IntlMessages id="assetPage.table.category" />,
      accessor: "category_label",
      minWidth: 100,
      sortable: true,
      position: 2,
      priorityLevel: 2,
    },
    {
      label: <IntlMessages id="assetPage.table.assetType" />,
      accessor: "type_label",
      minWidth: 100,
      sortable: true,
      position: 3,
      priorityLevel: 3,
    },
    {
      label: <IntlMessages id="assetPage.table.stateOrLevel" />,
      accessor: "state_label",
      minWidth: 100,
      sortable: true,
      position: 4,
      priorityLevel: 4,
      CustomComponent: (cell) => {
        let asset = cell.row;
        if (asset.category != "water") {
          return assetStates.map((value, index) => {
            const opacity = 0.3;
            const rgbValues = value.color.match(/\d+/g);
            const colorWithOpacity = `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, ${opacity})`;
            if (value.value == asset.state) {
              return (
                <div
                  className=""
                  style={{
                    display: "flex",
                    backgroundColor: colorWithOpacity,
                    padding: "5px 10px",
                    borderRadius: "10px",
                    gap: "6px",
                    maxWidth: "130px",
                    alignItems: "center",
                  }}
                >
                  <ColorItemPreview
                    style={{ backgroundColor: value.color }}
                  ></ColorItemPreview>
                  &nbsp;&nbsp;
                  <div>{value.label}</div>
                </div>
              );
            }
          });
        } else {
          return <div>{asset.state}</div>;
        }
      },
    },
    {
      label: "Available to contractors",
      accessor: "available_to_contractor",
      minWidth: 120,
      sortable: false,
      position: 5,
      priorityLevel: 5,
      CustomComponent: (cell) => {
        return cell.row.available_to_contractor ? "Yes" : "No";
      },
    },
    {
      label: <IntlMessages id="assetPage.table.location" />,
      accessor: "primary_object",
      minWidth: 200,
      sortable: true,
      position: 6,
      priorityLevel: 6,
    },
    {
      label: <IntlMessages id="assetPage.table.lastUsed" />,
      accessor: "last_activity_date",
      minWidth: 200,
      sortable: true,
      position: 7,
      priorityLevel: 7,
      CustomComponent: (cell) => {
        let asset = cell.row;
        return asset.last_activity_date
          ? moment(asset.last_activity_date).format("DD/MM/YYYY")
          : "N/A";
      },
    },
    {
      label: <IntlMessages id="assetPage.table.remaining" />,
      accessor: "remaining_label",
      minWidth: 100,
      sortable: true,
      position: 8,
      priorityLevel: 8,
    },
    {
      label: "",
      accessor: "actions",
      minWidth: 100,
      sortable: true,
      position: 9,
      priorityLevel: 9,
      noTitle: true,
      CustomComponent: (cell) => {
        let asset = cell.row;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            {/* One-click shortcut to the asset summary (same as the menu's
                "View Summary"), so it's not buried in the ⋮ dropdown. Only for
                machinery & spray — other categories have no summary data. */}
            {canViewSummary(asset) && (
              <EyeOutlined
                className="dotIcon"
                title="View Summary"
                style={{ cursor: "pointer", fontSize: 16 }}
                onClick={() => {
                  setSummaryDefaultTab("overview");
                  setViewSummary(asset);
                  setVisibleViewSummary(true);
                }}
              />
            )}
            <Dropdown overlay={menu(asset)} trigger={["click"]}>
              <div
                className="property-area-dot-btn"
                style={{ cursor: "pointer" }}
              >
                <EllipsisOutlined className="dotIcon" />
              </div>
            </Dropdown>
          </div>
        );
      },
    },
  ];

  const onSaved = (savedAsset) => {
    let tmpAssets = _.clone(assets);
    const Index = _.findIndex(tmpAssets, (asset) => {
      return asset.id === savedAsset.id;
    });

    if (Index === -1) {
      tmpAssets.push(savedAsset);
    } else {
      tmpAssets[Index] = savedAsset;
    }
    setAssets(tmpAssets);
    updatePropertyDetail(activePropertyId);
    setSearchQuery(tmpAssets);
  };

  const showModal = () => {
    const modalData = {
      type: "asset",
      canCreate: true,
    };
    dispatch(openModal(modalData));
  };

  const cancelEditTreatmentModal = () => {
    setVisibilityAssetTreatment(false);
  };

  const cancelEditFuelModal = () => {
    setVisibilityAssetFuel(false);
  };

  const cancelEditFeedModal = () => {
    setVisibilityAssetFeed(false);
  };

  const cancelEditWaterModal = () => {
    setVisibilityAssetWater(false);
  };

  const cancelEditAircraftModal = () => {
    setVisibilityAssetAircraft(false);
  };

  const cancelEditOtherModal = () => {
    setVisibilityAssetOther(false);
  };

  const cancelEditAnimalModal = () => {
    setVisibilityAssetAnimal(false);
  };

  const cancelEditWeatherModal = () => {
    setVisibilityAssetWeather(false);
  };

  const cancelEditSprayModal = () => {
    setVisibilityAssetSpray(false);
  };

  const cancelEditStorageModal = () => {
    setVisibilityAssetStorage(false);
  };

  // Assign-user / set-expiry close handlers. Always reset the loading
  // flag first so a slow-running PUT can't leave the modal "stuck" on a
  // spinner if the user cancels mid-request.
  const cancelAssignUserModal = () => {
    setVisibleAssignUser(false);
    setAssignUserLoading(false);
  };

  const cancelSetExpiryModal = () => {
    setVisibleSetExpiry(false);
    setSetExpiryLoading(false);
  };

  const handleAssignUserConfirm = (userId) => {
    // The Select disables the OK button when no user is picked, so this
    // branch is theoretically unreachable from the UI — surface it via
    // a visible message anyway so any future caller (or regression in
    // the modal's button state) doesn't fail silently in the dev's face.
    if (!assignTargetAsset) {
      console.error("handleAssignUserConfirm called with no target asset");
      return;
    }
    if (!userId) {
      message.error("Pick a user before confirming");
      return;
    }
    setAssignUserLoading(true);
    assetService
      .assignUser(assignTargetAsset.id, userId)
      .then((res) => {
        // Use the shared envelope helper — it covers both the legacy
        // { code: "0000" } shape and the new { success: true } shape
        // so this handler keeps working through the migration.
        if (isSuccess(res)) {
          message.success("User assigned");
          setVisibleAssignUser(false);
          updateAssetData();
          setAssetRefreshToken((t) => t + 1);
        } else {
          message.error(res?.message || "Failed to assign user");
        }
      })
      .catch((err) => {
        // 403 ForbiddenHttpException is the most likely failure here —
        // surface the backend message rather than a generic "error".
        const msg = err?.response?.data?.message || "Failed to assign user";
        message.error(msg);
      })
      .finally(() => setAssignUserLoading(false));
  };

  const handleSetExpiryConfirm = (expiryDate) => {
    if (!expiryTargetAsset) return;
    setSetExpiryLoading(true);
    assetService
      .setExpiry(expiryTargetAsset.id, expiryDate)
      .then((res) => {
        if (isSuccess(res)) {
          message.success(expiryDate ? "Expiry date saved" : "Expiry cleared");
          setVisibleSetExpiry(false);
          updateAssetData();
        } else {
          message.error(res?.message || "Failed to save expiry date");
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to save expiry date";
        message.error(msg);
      })
      .finally(() => setSetExpiryLoading(false));
  };

  const listAllMarkerArea = (object) => {
    const polygon = L.polygon([object.area]);
    const bounds = polygon.getBounds();

    var y_min = polygon.getBounds().getWest();
    var y_max = polygon.getBounds().getEast();
    var x_min = polygon.getBounds().getSouth();
    var x_max = polygon.getBounds().getNorth();
    const cellSide = markerGridHelper.cellSideForBounds(bounds);
    const options = { units: "kilometers" };
    const extent = [y_min, x_min, y_max, x_max];
    const grid = turf.pointGrid(extent, cellSide, options);

    let positionMarker = [];
    var area = polygon.getLatLngs()[0].map(function (point) {
      return [point.lat, point.lng];
    });
    _.forEach(grid.features, function (point) {
      if (
        inside(
          [point?.geometry?.coordinates[1], point?.geometry?.coordinates[0]],
          area
        ) &&
        point?.geometry?.coordinates[1] < object.lat_centroid
      ) {
        positionMarker.push({
          lat: point?.geometry?.coordinates[1].toFixed(8),
          lng: point?.geometry?.coordinates[0].toFixed(8),
        });
      }
    });

    // horizontally sort : lat
    positionMarker.sort(function (a, b) {
      if (a.lat < b.lat) return -1;
      if (a.lat > b.lat) return 1;
      if (a.lat == b.lat) {
        if (a.lat > b.lat) return -1;
        else return 1;
      }
    });

    // reverse array
    if (x_min > 0 && x_max > 0) {
      positionMarker = [...positionMarker].reverse();
    }

    // no grid point landed inside the paddock south of its centroid
    if (!positionMarker.length) {
      return [];
    }

    // arrange middle in array
    let xHorizontal = positionMarker.filter(
      (x) => x.lat == positionMarker[0].lat
    );

    let xMiddle = xHorizontal[Math.round((xHorizontal.length - 1) / 2)];
    let yAllMiddle = positionMarker.filter((y) => y.lng == xMiddle.lng);
    let YMiddle = yAllMiddle[Math.round((yAllMiddle.length - 1) / 2)];
    let xUnderName = positionMarker.filter((x) => x.lat == YMiddle.lat);

    let xMarkerSort = [];
    _.forEach(xUnderName, function (pM, i) {
      // get middle item
      xMiddle = xUnderName[Math.round((xUnderName.length - 1) / 2)];

      // get index middle item
      var indexMiddle = _.findIndex(xUnderName, xMiddle);
      if (!_.find(xMarkerSort, xMiddle)) {
        xMarkerSort.push(xMiddle);
        xUnderName.splice(indexMiddle, 1);
      }
    });

    return xMarkerSort;
  };

  const handleCancelSearch = () => {
    setsearchInput("");
    setSearchQuery(assets);
  };
  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    const searchTerm = searchInput.toLowerCase();
    // if (e.key === "Enter") {
    const filteredAssets = assets.filter((asset) => {
      return (
        asset.title.toLowerCase().includes(searchTerm) ||
        asset.category_label.toLowerCase().includes(searchTerm) ||
        asset.type_label.toLowerCase().includes(searchTerm) ||
        asset.state_label.toLowerCase().includes(searchTerm) ||
        (asset.primary_object &&
          asset.primary_object.toString().toLowerCase().includes(searchTerm)) ||
        (asset.last_activity_date &&
          moment(asset.last_activity_date)
            .format("DD/MM/YYYY")
            .includes(searchTerm)) ||
        asset.remaining_label.toLowerCase().includes(searchTerm)
      );
    });
    setSearchQuery(filteredAssets);
    setCurrentPage(1); // Reset the current page to 1 when the search term changes
    // }
  };

  const cancelModalHistory = () => {
    setVisibleAddHistory(false);
  };

  const cancelModalActivity = () => {
    setVisibleModalActivity(false);
    setActivityActive(null);
  };
  // const updateDataAssetHistory = React.useCallback(
  //   (asset_id, modal_type) => {
  //     activityService.getList(asset_id, modal_type).then((res) => {
  //       if (res.code === "0000") {
  //         setAssetHistory(res.activities.reverse());
  //         //setLoading(false);
  //       }
  //     });
  //   },
  //   [assetHistory]
  // );
  return (
    <LayoutWrapper>
      {/* Suppress the global yellow focus glow inside the new assign-user
          / set-expiry modals (they portal to document.body, so AssetPage
          styled scoping doesn't reach them). */}
      <AssetModalGlobalStyles />
      <AssetPage>
        <Box id="containerBox">
          <div className="manage-property-header">
            <div className="mp-title">
              <h2 className="manage-property-title">Asset</h2>
            </div>
            {props.search_result ? (
              ""
            ) : (
              <>
                <Input
                  placeholder="Search…"
                  size="large"
                  className="search-bar"
                  value={searchInput}
                  onChange={(e) => handleSearch(e)}
                  suffix={
                    !searchInput && (
                      <SearchOutlined className="site-form-item-icon" />
                    )
                  }
                  prefix={
                    !searchInput ? (
                      <>
                        <SearchOutlined className="site-form-item-icon" />
                      </>
                    ) : (
                      <CloseCircleOutlined
                        onClick={handleCancelSearch}
                        className="site-form-item-cancel"
                      />
                    )
                  }
                />
                <div className="button-group">
                  {(activePermission == "owner" ||
                    activePermission == "admin" ||
                    activePermission == "safety") && (
                    <Button
                      icon={<ToolOutlined />}
                      onClick={() => setVisibleTemplateModal(true)}
                      style={{ marginRight: 10, whiteSpace: "nowrap" }}
                      disabled={!activePropertyId}
                    >
                      Checklist Templates
                    </Button>
                  )}
                  {(activePermission == "owner" ||
                    activePermission == "admin") && (
                    <Button
                      icon={<PlusOutlined />}
                      type="primary"
                      className="btn-success"
                      onClick={showModal}
                    >
                      <IntlMessages id="assetPage.managePage.addAsset" />
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
          {props.search_result &&
          props.search_result.Facility &&
          props.search_result.Facility.length > 0 ? (
            <>
              <div className="manage-table">
                <Table
                  columns={columns}
                  rows={displayData}
                  containerId="containerBox"
                  showPagination={false}
                  rowSize={99999}
                />
              </div>
              {props.search_result?.Facility?.length > 10 && (
                <div style={{ padding: "16px" }}>
                  <Pagination
                    current={currentPage}
                    total={props.search_result.Facility?.length}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50", "100"]}
                    onShowSizeChange={handlePageSizeChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="manage-table">
              {loadingData ? (
                <Loader />
              ) : (
                <>
                  {!props.search_result &&
                  assets &&
                  assets.length > 0 ? (
                    <>
                      <Table
                        columns={columns}
                        rows={assets}
                        containerId="containerBox"
                        showPagination={false}
                        rowSize={99999}
                        showSearch={false}
                      />
                      <div style={{ padding: "16px" }}>
                        <Pagination
                          current={currentPage}
                          total={assetTotal}
                          pageSize={pageSize}
                          onChange={handlePageChange}
                          showSizeChanger
                          pageSizeOptions={["10", "20", "50", "100"]}
                          onShowSizeChange={handlePageSizeChange}
                        />
                      </div>
                    </>
                  ) : (
                    <h1 style={{ padding: "15px 25px", color: "gray" }}>
                      <IntlMessages id="No assets found under this property" />
                    </h1>
                  )}{" "}
                </>
              )}
            </div>
          )}
        </Box>
        <AssetModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          property={propertyDetail}
          onSaved={onSaved}
          listAllMarkerArea={listAllMarkerArea}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <ChecklistTemplatesModal
          visible={visibleTemplateModal}
          onCancel={() => setVisibleTemplateModal(false)}
          propertyId={activePropertyId}
        />
        <EditTreatmentModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetTreatment={visibleAssetTreatment}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditTreatmentModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditFuelModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetFuel={visibleAssetFuel}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditFuelModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditFeedModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetFeed={visibleAssetFeed}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditFeedModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditWaterModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetWater={visibleAssetWater}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditWaterModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditAircraftModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetAircraft={visibleAssetAircraft}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditAircraftModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditGeneralAssetModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          updatePropertyDetail = {updatePropertyDetail}
          visibleAssetOther={visibleAssetOther}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditOtherModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
          setVisibleAddHistory={setVisibleAddHistory}
          visibleAddHistory={visibleAddHistory}
        />
        <EditAnimalModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetAnimal={visibleAssetAnimal}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditAnimalModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditWeatherModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visibleAssetWeather={visibleAssetWeather}
          dataAsset={dataAsset}
          cancelEditModal={cancelEditWeatherModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <EditSprayModal
          propertyId={activePropertyId}
          onSaved={onSaved}
          visible={visibleAssetSpray}
          dataAsset={dataAsset}
          onCancel={cancelEditSprayModal}
          primaryObjects={primaryObjects}
        />
        <EditStorageModal
          updateDataAssets={updateAssetData}
          propertyId={activePropertyId}
          primaryObjects={primaryObjects}
          onSaved={onSaved}
          visible={visibleAssetStorage}
          dataAsset={dataAsset}
          onCancel={cancelEditStorageModal}
          setViewHistory={setViewHistory}
          viewHistory={viewHistory}
        />
        <AddActivityModal
          visibleActivity={visibleModalActivity}
          dataId={dataAsset?.id}
          propertyId={activePropertyId}
          cancelModalActivity={cancelModalActivity}
          getDataActivity={updateAssetData}
          onSaved={onSaved}
          defaultActivityType={activityActive}
          assetName={dataAsset?.title}
          educationAsset={dataAsset?.education_asset || null}
        />
        <AssetAssignUserModal
          visible={visibleAssignUser}
          propertyId={activePropertyId}
          initialUserId={assignTargetAsset?.assigned_user_id || null}
          assetName={assignTargetAsset?.title || ""}
          onCancel={cancelAssignUserModal}
          onConfirm={handleAssignUserConfirm}
          confirmLoading={assignUserLoading}
        />
        <AssetSetExpiryModal
          visible={visibleSetExpiry}
          initialExpiry={expiryTargetAsset?.expiry_date || null}
          assetName={expiryTargetAsset?.title || ""}
          onCancel={cancelSetExpiryModal}
          onConfirm={handleSetExpiryConfirm}
          confirmLoading={setExpiryLoading}
        />
      </AssetPage>

      <SelectPropertyModal
        visibleSelectProperty={visibleSelectProperty}
        cancelSelectPropertyModal={cancelSelectPropertyModal}
      />
      <AssetViewSummary
        visibleViewSummary={visibleViewSummary}
        setVisibleViewSummary={setVisibleViewSummary}
        viewSummary={viewSummary}
        refreshToken={assetRefreshToken}
        defaultTab={summaryDefaultTab}
        onStartPreStart={(asset) => {
          setInspectionAsset(asset);
          setVisibleInspection(true);
        }}
        onAssignOperator={(asset) => {
          setAssignTargetAsset(asset);
          setVisibleAssignUser(true);
        }}
        onUnassignOperator={(asset) => {
          assetService.unassignUser(asset.id).then((res) => {
            if (isSuccess(res)) {
              message.success("Operator unassigned");
              updateAssetData();
              setAssetRefreshToken((t) => t + 1);
            } else {
              message.error(res?.message || "Failed to unassign operator");
            }
          });
        }}
        onLogService={(asset) => {
          setLogServiceAsset(asset);
          setVisibleLogService(true);
        }}
      />
      <LogServiceModal
        visible={visibleLogService}
        asset={logServiceAsset}
        onCancel={() => setVisibleLogService(false)}
        onSaved={() => {
          setVisibleLogService(false);
          updateAssetData();
        }}
      />
      <PreStartInspectionModal
        visible={visibleInspection}
        asset={inspectionAsset}
        onCancel={() => setVisibleInspection(false)}
        onSaved={() => {
          setVisibleInspection(false);
        }}
      />
      <AddAssetHistoryModal
        history="Add"
        visibleHistory={visibleAddHistory}
        cancelModal={cancelModalHistory}
        primaryObjects={primaryObjects}
        model="facilities"
        dataId={dataAsset?.id}
        propertyId={activePropertyId}
        assetName={dataAsset?.name || dataAsset?.title || dataAsset?.asset_name || 'N/A'}
        updateDataAssetHistory={updateAssetData}
        onAssetUpdated={updateAssetData}
        updatePropertyDetail={updatePropertyDetail}
      />
    </LayoutWrapper>
  );
};

export default Asset;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div {
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;
